import { render, staticRenderFns } from "./PayTypeCheckList.vue?vue&type=template&id=12ad5ad8&"
import script from "./PayTypeCheckList.vue?vue&type=script&lang=ts&"
export * from "./PayTypeCheckList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports